
import React from 'react';
import RegisterForm from '@/components/auth/RegisterForm';
import { Wallet } from 'lucide-react';

const Register: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center p-4 bg-gray-50">
      <div className="mb-8 text-center">
        <div className="flex items-center justify-center mb-4">
          <div className="bg-royalty-600 p-2 rounded-full">
            <Wallet className="h-8 w-8 text-white" />
          </div>
        </div>
        <h1 className="text-3xl font-bold text-royalty-700">Author Royalty Management</h1>
        <p className="text-gray-600 mt-2">Create an account to manage your royalties</p>
      </div>
      
      <RegisterForm />
    </div>
  );
};

export default Register;
